import { AREAL_OPTIONS, GKZ_OPTIONS } from './utils';

export const TURNUS_OPTIONS = [
  { value: 'weekly', label: '7-tägig' },
  { value: 'biweekly', label: '14-tägig' },
  { value: 'individual', label: 'individuell' },
];

export function parseCourseRhythm(raw) {
  const s = String(raw || '').trim().toLowerCase();
  if (!s) return 'weekly';
  if (s === 'biweekly' || s.startsWith('14')) return 'biweekly';
  if (s === 'individual' || s === 'individuell' || s === 'flex') return 'individual';
  if (s === 'weekly' || s === '7' || s.startsWith('wöch') || s.startsWith('woech')) return 'weekly';
  return 'weekly';
}

/** Katalog für schrittweise Belegungs-Suche (eMeike/iMikel-Stil). */
export const ENROLLMENT_CRITERIA_FIELDS = [
  { key: 'q_bezeichnung', label: 'Bezeichnung / Kurs / Schule', suggest: true, placeholder: 'z. B. Waldschule Leschede' },
  { key: 'q_fach', label: 'Fach', suggest: true, placeholder: 'z. B. Klavier' },
  { key: 'q_unterrichtsform', label: 'Tarif / Unterrichtsart', suggest: true },
  { key: 'q_standort', label: 'Veranstaltungsort / Unterrichtsort', suggest: true, placeholder: 'Standort oder Schule' },
  { key: 'q_gkz', label: 'GKZ / Filiale', type: 'select', options: GKZ_OPTIONS, suggest: true },
  { key: 'q_areal', label: 'Areal / Region', type: 'select', options: AREAL_OPTIONS, suggest: true },
  { key: 'q_lehrkraft', label: 'Lehrkraft', suggest: true },
  { key: 'q_kassenzeichen', label: 'Kassenzeichen', placeholder: 'Kassenz.…' },
  { key: 'q_student_name', label: 'Teilnehmer:in', suggest: true },
  { key: 'q_student_address', label: 'Adresse (Teilnehmer:in)', placeholder: 'Straße…' },
  { key: 'q_student_plz_ort', label: 'PLZ/Ort (Teilnehmer:in)', placeholder: 'PLZ oder Ort' },
  { key: 'q_student_dob', label: 'Geburtsdatum', placeholder: 'TT.MM.JJJJ' },
  { key: 'q_payer_name', label: 'Zahlungspflichtige:r', suggest: true },
  { key: 'q_payer_address', label: 'Adresse (Zahlungspflichtige:r)', placeholder: 'Straße…' },
  { key: 'q_payer_plz_ort', label: 'PLZ/Ort (Zahlungspflichtige:r)', placeholder: 'PLZ oder Ort' },
  { key: 'q_payer_areal', label: 'Areal (Zahlungspflichtige:r)', suggest: true },
  { key: 'q_kontakt', label: 'Telefon / E-Mail', placeholder: 'Nummer oder E-Mail' },
  { key: 'q_kontoinhaber', label: 'Kontoinhaber' },
  { key: 'q_bank', label: 'Bank' },
  { key: 'q_iban', label: 'IBAN', placeholder: 'DE…' },
  { key: 'q_bic', label: 'BIC' },
  { key: 'q_mandat', label: 'Mandatsreferenz' },
  { key: 'q_mandat_datum', label: 'Mandat erteilt am', placeholder: 'TT.MM.JJJJ' },
  { key: 'q_einzugstag', label: 'Zahlungstermin', type: 'select', options: [
    { value: '1', label: 'zum 1. des Monats' },
    { value: '15', label: 'zum 15. des Monats' },
  ] },
  { key: 'q_zahlungsart', label: 'Zahlungstyp', type: 'select', options: [
    { value: 'sepa', label: 'SEPA-Lastschrift' },
    { value: 'transfer', label: 'Selbstzahler / Überweisung' },
  ] },
  { key: 'q_zahlungssperre', label: 'Zahlungssperre', type: 'select', options: [
    { value: 'ja', label: 'Ja' },
    { value: 'nein', label: 'Nein' },
  ] },
  { key: 'q_sepa_mandat', label: 'SEPA-Mandat', type: 'select', options: [
    { value: 'vorhanden', label: 'vorhanden' },
    { value: 'fehlt', label: 'nicht vorhanden' },
  ] },
  { key: 'q_mandant', label: 'Mandant', placeholder: 'MAG, MAO, …' },
  { key: 'status', label: 'Belegungsstatus', type: 'select', options: [
    { value: 'active', label: 'Aktiv' },
    { value: 'paused', label: 'Pausiert' },
    { value: 'cancelled', label: 'Gekündigt' },
    { value: 'completed', label: 'Abgeschlossen' },
  ] },
  { key: 'q_student_status', label: 'Schüler:in aktiv/inaktiv', type: 'select', options: [
    { value: 'active', label: 'Aktiv' },
    { value: 'inactive', label: 'Inaktiv' },
    { value: 'paused', label: 'Pausiert' },
  ] },
  { key: 'q_raum', label: 'Raum', suggest: true },
  { key: 'q_termin', label: 'Tag / Wochentag', suggest: true, placeholder: 'Mo, Di, …' },
  { key: 'q_zeit', label: 'Uhrzeit', placeholder: '16:30' },
  { key: 'q_dauer', label: 'Dauer (Min.)', suggest: true },
  { key: 'q_turnus', label: 'Turnus / Rhythmus', type: 'select', options: TURNUS_OPTIONS, placeholder: '7-tägig, 14-tägig oder individuell' },
  { key: 'q_student_age', label: 'Alter', placeholder: '>18, <18, =25' },
  { key: 'q_eintritt', label: 'Eintritt', placeholder: 'TT.MM.JJJJ' },
  { key: 'q_austritt', label: 'Austritt', placeholder: 'TT.MM.JJJJ' },
  { key: 'q_rabatt', label: 'Rabattart', placeholder: 'z. B. Familienpass' },
  { key: 'q_rabatt_betrag', label: 'Rabattbetrag', placeholder: '15, 15 € oder 10%' },
  { key: 'q_rabatt_art', label: 'Rabatt vorhanden', type: 'select', options: [
    { value: 'any', label: 'irgendein Rabatt' },
    { value: 'none', label: 'kein Rabatt' },
  ] },
  { key: 'q_rabatt_beginn', label: 'Rabatt Beginn', placeholder: 'TT.MM.JJJJ oder 01.01.2026-31.12.2026' },
  { key: 'q_rabatt_ende', label: 'Rabatt Ende', placeholder: 'Dezember 2026 oder TT.MM.JJJJ' },
  { key: 'q_rabatt_gueltig', label: 'Rabatt gültig im Zeitraum', placeholder: 'Oktober 2026' },
  { key: 'q_rabatt_laufzeit', label: 'Rabatt-Laufzeit', placeholder: 'unbefristet, befristet oder 12 Monate' },
  { key: 'q_rabatt_status', label: 'Rabatt-Status', type: 'select', options: [
    { value: 'aktiv', label: 'aktiv' },
    { value: 'zukuenftig', label: 'zukünftig' },
    { value: 'abgelaufen', label: 'abgelaufen' },
  ] },
  { key: 'q_rabatt_einheit', label: 'Rabatt Einheit', type: 'select', options: [
    { value: 'fixed', label: 'Betrag (€)' },
    { value: 'percentage', label: 'Prozent' },
  ] },
  { key: 'q_rabatt_gebuehr', label: 'Rabatt auf Gebühr', type: 'select', options: [
    { value: 'unterricht', label: 'Unterrichtsgebühr' },
    { value: 'gema', label: 'GEMA/Lizenz' },
    { value: 'zusatz', label: 'Zusatz' },
  ] },
  { key: 'q_rabatt_ausweis', label: 'Ausweis-Nr.', placeholder: 'Ausweisnummer' },
  { key: 'q_rabatt_aussteller', label: 'Aussteller', placeholder: 'z. B. Stadt Greven' },
  { key: 'q_rabatt_aktenzeichen', label: 'Aktenzeichen' },
  { key: 'q_rabatt_notiz', label: 'Rabatt-Notiz' },
];

export const MISSING_CRITERION = 'leer';

const MISSING_WORDS = new Set(['leer', 'fehlt', 'fehlend', 'ohne', 'keine', 'keiner', 'keins', 'empty']);

export function isMissingCriterion(value) {
  return MISSING_WORDS.has(String(value || '').trim().toLowerCase());
}

const fieldByKey = Object.fromEntries(ENROLLMENT_CRITERIA_FIELDS.map((f) => [f.key, f]));

export function criteriaFieldLabel(key) {
  return fieldByKey[key]?.label || key;
}

export function criteriaDisplayValue(key, value) {
  if (!value) return '';
  if (isMissingCriterion(value)) return 'leer';
  const field = fieldByKey[key];
  if (field?.type === 'select' && field.options) {
    return field.options.find((o) => o.value === value)?.label || value;
  }
  return value;
}

export function criteriaToParams(criteria) {
  const params = {};
  Object.entries(criteria || {}).forEach(([k, v]) => {
    if (v != null && String(v).trim()) params[k] = String(v).trim();
  });
  return params;
}

export const SEARCH_PLACEHOLDER = 'Suchbegriff…';

/** Leere Suchfelder: weiß/hellgrau. Nur gesetzte Kriterien: Rosé + Bordeaux-Rahmen. */
export function searchInputClassName(value, extra = '') {
  const filled = value != null && String(value).trim() !== '';
  const tone = filled
    ? 'border-brand-red/70 bg-rose-50 placeholder:text-slate-400'
    : 'border-slate-200 bg-white placeholder:text-slate-400';
  return `${extra} ${tone}`.trim();
}

export function validateCriteriaParams(params) {
  if (Object.keys(params).length === 0) {
    return 'Bitte mindestens ein Suchkriterium angeben';
  }
  if (params.q_student_age) {
    const ageOk = /^(alter\s*)?(>=|<=|>|<|=)?\s*\d{1,3}$/i.test(params.q_student_age);
    if (!ageOk) return 'Alter: bitte z. B. >18, >=18, <18 oder =25 eingeben';
  }
  return null;
}
